export const WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID";
export const INJECTED_PROVIDER_ID = "injected";
export const CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER";
